/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_8_TitleInputs */

const en_privacy_section_8_title = /** @type {(inputs: Privacy_Section_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Contact`)
};

const lv_privacy_section_8_title = /** @type {(inputs: Privacy_Section_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Kontakti`)
};

/**
* | output |
* | --- |
* | "8. Contact" |
*
* @param {Privacy_Section_8_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_8_title = /** @type {((inputs?: Privacy_Section_8_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_8_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_8_title(inputs)
	return en_privacy_section_8_title(inputs)
});